export default{
    data:{
        roleList:[],
        deptRoleList:[],
        departmentTree: [],
        empList:[]
    },
    methods:{
        getRoles(formData,token){
            this.$axios({
                method: "post",
                url: "/shiro/role/getAll",
                data: formData, 
                headers: {
                    token: token
                }
            }).then(result => {
                this.roleList=result.data.data
            })
            return this.roleList;
        },
        getDeptRole(formData,token){
            this.$axios({
                method: "post",
                url: "/shiro/role/getDeptRole",
                data: formData, 
                headers: {
                    token: token
                }
            }).then(result => {
                this.deptRoleList=result.data.data
            })
            return this.deptRoleList;
        },
        getDepartmentTree(formData,token) {
            this.$axios({
                method: "post",
                url: "/shiro/department/getTree",
                data: formData,
                headers: {
                    token: token
                }
            }).then(result => {
                this.departmentTree = result.data.data
            })
            return this.departmentTree;
        },
        getEmpsByRoleId(formData,token) {
            this.$axios({
                method: "post",
                url: "/shiro/employee/getAll/roleId",
                data: formData,
                headers: {
                    token: token
                }
            }).then(result => {
                this.empList = result.data.data
                
                for (let key in this.empList) {
                    this.empList[key].createdTime = this.$moment(this.empList[key].createdTime).format("YYYY-MM-DD HH:mm")
                    this.empList[key].status =this.empList[key].status==1?'启用':'禁用'
                }

                // callback()
            })
            
            return this.empList;
        }
    }
}